import { useState } from 'react';
import { RouterProvider } from 'react-router';
import { SessionProvider } from '../features/session/SessionProvider';
import { createRouter } from './router';

export function App() {
  const [router] = useState(createRouter);
  return (
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  );
}
